module.exports = __webpack_public_path__ + "img/3.ccc0b6c8.png";